import React, { useState, useEffect } from "react";
import Post from "../post/Post";
import { useFilter } from "../filterContext/FilterContext";

const PostList = ({ searchQuery }) => {
    const [posts, setPosts] = useState([]);
    const { filter, filterTag, onlyOfficial } = useFilter();

    const fetchPosts = () => {
        const url = new URL(`${process.env.REACT_APP_API_URL}/posts`, window.location.origin);
        if (searchQuery) {
            url.searchParams.append('search', searchQuery);
        }
        url.searchParams.append('sort', filter);
        if (filterTag != "null" && filterTag != null)
            url.searchParams.append('filterTag', filterTag);
        if (onlyOfficial == true)
            url.searchParams.append('onlyOfficial', onlyOfficial);

        fetch(url)
            .then(response => response.json())
            .then(data => {
                setPosts(data || []);  // Ensure data is an array
            })
            .catch(error => {
                console.error("Error fetching posts:", error);
                setPosts([]);  // Handle fetch errors gracefully
            });
    };

    useEffect(() => {
        fetchPosts();

        const intervalId = setInterval(() => {
            fetchPosts();
        }, 1000);  // Polling every 5 seconds

        return () => clearInterval(intervalId);  // Cleanup interval on component unmount
    }, [searchQuery, filter, filterTag, onlyOfficial]);

    return (
        <div className="post-list">
            {posts.map((post, index) => (
                <Post key={post.id_postare} postData={post} index={index} />
            ))}
        </div>
    );
};

export default PostList;
